import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { StudentContext } from '../StudentContext';
import QRScannerOfParent from './QRScannerOfParent';
import Student from './Student';
import './ParentView.css';

// Hàm bỏ dấu tiếng Việt
const removeAccents = (str) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
};

const ParentView = () => {
  const [studentId, setStudentId] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const { studentsData, isLoading, loadAllData } = useContext(StudentContext);

  useEffect(() => {
    if (Object.keys(studentsData).length === 0 && !isLoading) {
      console.log('ParentView: Loading all data for parent view');
      loadAllData();
    }
  }, [studentsData, isLoading, loadAllData]);

  const handleToggleScanner = () => {
    if (!showScanner) {
      setIsButtonDisabled(true);
      setShowScanner(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
    } else {
      setShowScanner(false);
      setIsButtonDisabled(false); // Reset trạng thái khi đóng
    }
  };

  const handleNameSearch = (e) => {
    const value = e.target.value;
    setSearchName(value);

    if (value.trim() === '') {
      setSuggestions([]);
      return;
    }

    const normalizedSearch = removeAccents(value.normalize('NFC')).toLowerCase();

    const filteredSuggestions = [];
    for (const classId in studentsData) {
      const matchingStudents = studentsData[classId].filter((student) => {
        const normalizedFullName = removeAccents(student.fullName.normalize('NFC')).toLowerCase();
        return normalizedFullName.includes(normalizedSearch);
      });
      filteredSuggestions.push(...matchingStudents);
    }

    setSuggestions(filteredSuggestions.slice(0, 5));
  };

  const handleSuggestionClick = (studentId) => {
    setSearchName('');
    setSuggestions([]);
    navigate(`/parent/student/${studentId}`);
  };

  const handleIdSubmit = (e) => {
    e.preventDefault();
    if (studentId.trim()) {
      let studentExists = false;
      for (const classId in studentsData) {
        if (studentsData[classId].some((student) => student.id === studentId.trim())) {
          studentExists = true;
          break;
        }
      }
      if (studentExists) {
        navigate(`/parent/student/${studentId.trim()}`);
      } else {
        alert('Không tìm thấy thiếu nhi với ID này');
      }
    }
  };

  const handleQRScanned = (result) => {
    if (result) {
      setShowScanner(false);
      setIsButtonDisabled(false);
      navigate(`/parent/student/${result}`);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <img src="/logo.png" alt="Logo" className="parentView-container" />
        <h2 className="welcome-message">Chào mừng quý phụ huynh đến với giáo xứ An Nhơn</h2>
        <div className="loading-bar-container">
          <div className="loading-bar"></div>
          <p className="loading-text">Đang tải dữ liệu...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="parent-container">
      <div className="parent-header">
        <h2>Tra cứu thông tin thiếu nhi</h2>
        <button onClick={() => navigate('/login')} className="logout-button">
          Đăng xuất
        </button>
      </div>

      <div className="search-section">
        <form onSubmit={handleIdSubmit} className="search-form">
          <input
            type="text"
            value={studentId}
            onChange={(e) => setStudentId(e.target.value)}
            placeholder="Nhập ID thiếu nhi"
            className="search-input"
          />
          <button type="submit" className="search-button">
            Tìm kiếm
          </button>
        </form>

        <div className="search-name-section">
          <input
            type="text"
            value={searchName}
            onChange={handleNameSearch}
            placeholder="Nhập Họ và Tên thiếu nhi"
            className="search-input search-name-input"
          />
          {suggestions.length > 0 && (
            <ul className="suggestions-list">
              {suggestions.map((student) => (
                <li
                  key={student.id}
                  className="suggestion-item"
                  onClick={() => handleSuggestionClick(student.id)}
                >
                  <b>{student.fullName}</b> ({student.className}) ({student.id})
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="qr-section">
          <button
            onClick={handleToggleScanner}
            className="qr-button"
            disabled={isButtonDisabled && showScanner}
          >
            {showScanner ? 'Đóng máy quét' : 'Quét QR Code'}
          </button>
          {showScanner && (
            <div className="scanner-container">
              <QRScannerOfParent onScan={handleQRScanned} />
            </div>
          )}
        </div>
      </div>

      <div className="instructions">
        <h3>Hướng dẫn tra cứu:</h3>
        <ol>
          <li>Nhập ID hoặc Họ và Tên thiếu nhi vào ô tìm kiếm</li>
          <li>Bấm nút "Quét QR Code" để quét mã QR từ thẻ ID của thiếu nhi</li>
        </ol>
      </div>
    </div>
  );
};

export default ParentView;